import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";

export const PinGate = ({ onSuccess }) => {
  const [pin, setPin] = useState("");
  const [err, setErr] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.verify(pin);
      sessionStorage.setItem("admin_pin", pin);
      onSuccess();
    } catch { setErr("Invalid PIN"); }
  };
  return (
    <div className="min-h-screen flex items-center px-6 relative z-10">
      <form onSubmit={submit} className="w-full max-w-sm border border-white/10 bg-[#121212] p-8 fade-up" data-testid="pin-gate">
        <img src="/logo-64.png" alt="CellCheckPoint" className="w-12 h-12" data-testid="pin-logo" />
        <h1 className="font-display text-5xl mt-4">Admin Access</h1>
        <p className="text-xs text-neutral-500 mt-1">Enter PIN to view the network dashboard.</p>
        <input data-testid="admin-pin-input" type="password" autoFocus value={pin} onChange={(e) => setPin(e.target.value)}
          className="field w-full mt-6 text-center tracking-[0.5em] text-lg" placeholder="••••" />
        {err && <div className="text-[#FF3B30] text-xs mt-2" data-testid="pin-error">{err}</div>}
        <button data-testid="admin-pin-submit" className="btn-primary w-full py-3 mt-4 font-display text-2xl tracking-widest">Unlock</button>
        <Link to="/" className="label block mt-4 hover:text-white" data-testid="pin-back-link">← Back to speed test</Link>
      </form>
    </div>
  );
};
